module.exports = __webpack_public_path__ + "img/59.54c75d72.webp";